<template>
    <div class="preorder-selection">
        <transition-group name="fade">
            <div
                v-if="page === 'selection'"
                key="selection"
                class="selection"
            >
                <!-- BlocksStationsFunctionsFoodMenu
                    :menu="computedMenu"
                    :selected="selection"
                    @select="select"
                / -->
                <template v-for="item in selectedItems" :key="`item-${item.id}-${item.variation}`">
                    <div
                        :class="{
                            'selected': productAmount(item.id, item.variation) > 0,
                        }"
                        class="item"
                    >
                        <DSFrontifyAsset
                            fill="cover"
                            :asset="item.image"
                        />
                        <div class="content">
                            <div class="text">
                                <h3 class="h5">{{ item.name }}</h3>
                                <DSCFText v-if="item.description" :content="item.description" />
                                <span
                                    v-if="item.specialties"
                                    class="specialties"
                                >{{ item.specialties.join(', ') }}</span>
                            </div>
                            <div class="price-group">
                                <span class="price">{{ $cms.formatPrice(item.price) }}</span>
                                <span v-if="item.variation" class="variation">{{ item.variationName }}</span>
                            </div>
                            <DSNumber
                                :data-key="item.id"
                                :value="productAmount(item.id, item.variation)"
                                @change="values => setProduct({
                                    id: values.dataKey,
                                    variation: item.variation,
                                    variationName: item.variationName,
                                    description: item.description,
                                    specialties: item.specialties,
                                    image: item.image,
                                    title: item.name,
                                    amount: values.value,
                                    price: item.price,
                                    list: {
                                        ...selectedList,
                                    },
                                })"
                            />
                        </div>
                    </div>
                    <div
                        class="padding"
                    >
                        <DSHeightTransition :open="productAmount(item.id, item.variation) > 0">
                            <div class="extras">
                                <div
                                    v-for="extra in item.extras"
                                    :key="`extra-${item.id}-${item.variation}-${extra.id}`"
                                    class="extra"
                                >
                                    <span class="add"><DSIcon code="default-fill/add" /></span>
                                    <div class="content">
                                        <h4 class="h5">{{ extra.name }}</h4>
                                        <DSCFText
                                            v-if="extra.description"
                                            class="description"
                                            :content="extra.description"
                                        />
                                    </div>
                                    <div class="price-group">
                                        <p class="price">{{ $cms.formatPrice(extra.price) }}</p>
                                    </div>
                                    <DSNumber
                                        :key="`${item.id}-${item.variation}-${extra.id}`"
                                        :data-key="`${item.id}-${item.variation}-${extra.id}`"
                                        :value="productAmount(item.id, item.variation, extra.id)"
                                        @change="values => setProduct({
                                            id: item.id,
                                            variation: item.variation,
                                            extra: extra.id,
                                            category: selectedList.category,
                                            description: extra.description,
                                            specialties: extra.specialties,
                                            image: extra.image,
                                            title: extra.name,
                                            amount: values.value,
                                            price: extra.price,
                                            list: {
                                                ...selectedList,
                                            },
                                        })"
                                    ></DSNumber>
                                </div>
                            </div>
                        </DSHeightTransition>
                    </div>
                </template>
            </div>
            <div
                v-else-if="page ==='checkout'"
                key="checkout"
                class="checkout"
            >
                <template v-for="item in products" :key="item.id">
                    <div class="item">
                        <DSFrontifyAsset
                            fill="cover"
                            :asset="item.image"
                        />
                        <div class="content">
                            <h3 class="h5">{{ item.title }}</h3>
                            <DSCFText
                                v-if="item.description"
                                class="description"
                                :content="item.description"
                            />
                            <span
                                v-if="item.specialties"
                                class="specialties"
                            >{{ item.specialties.join(', ') }}</span>
                            <div class="price-group">
                                <div class="price">{{ $cms.formatPrice(item.price * item.amount) }}</div>
                                <div class="amount">{{ `${item.amount} ${$t('amount')}` }}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="item.extras"
                        :key="`extras-${item.id}-${item.variation}`"
                        class="extras"
                    >
                        <div
                            v-for="extra in item.extras"
                            :key="`extra-${item.id}-${item.variation}-${extra.extra}`"
                            class="extra"
                        >
                            <span class="add"><DSIcon code="default-fill/add" /></span>
                            <div class="content">
                                <h4 class="h5">{{ extra.title }}</h4>
                                <DSCFText
                                    v-if="extra.description"
                                    class="description"
                                    :content="extra.description"
                                />
                            </div>
                            <div class="price-group">
                                <div class="price">{{ $cms.formatPrice(extra.amount * extra.price) }}</div>
                                <div class="amount">{{ extra.amount }} {{ $t('amount') }}</div>
                            </div>
                        </div>
                    </div>
                </template>
                <hr class="checkout-divider">
                <p class="disclaimer">{{ $t('listPriceNotification') }}</p>
            </div>
        </transition-group>
        <portal to="footer-toolbar">
            <div :key="`${page}`" class="toolbar">
                <transition name="fade">
                    <div v-if="station.id" class="totals">
                        <transition-group
                            name="fade"
                            tag="div"
                            class="inner"
                        >
                            <button
                                v-if="page === 'selection'"
                                key="to-checkout"
                                class="ds-btn ds-btn--secondary"
                                :disabled="products.length === 0"
                                @click="navigate('checkout')"
                            >
                                {{ $t('order') }}
                            </button>
                            <button
                                v-else
                                key="back"
                                class="ds-btn ds-btn--secondary"
                                @click="navigate('selection')"
                            >
                                <DSIcon code="default-line/arrow-left" />
                                {{ $t('back') }}
                            </button>
                            <a
                                v-if="station.telephone"
                                key="phone"
                                class="ds-btn ds-btn--primary phone"
                                :href="`tel:${station.telephone}`"
                            >
                                <DSIcon code="default-fill/call" size="l" />
                                {{ $t('call') }}: {{ station.telephone }}
                            </a>
                        </transition-group>
                    </div>
                </transition>
            </div>
        </portal>
    </div>
</template>
<script>
export default {
    name: 'StationsPreorderSelection',
    props: {
        station: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    data: () => ({
        page: 'selection',
        selection: {
            root: 0,
            category: 0,
        },
    }),
    computed: {
        computedMenu() {
            return (this.station?.menu?.items ?? [])
                .map((item, key) => ({
                    id: item.id,
                    index: key,
                    title: item.title,
                    items: (item?.items ?? []).filter(this.isProductMenu).map((subItem, subKey) => ({
                        id: subItem.id,
                        index: subKey,
                        title: subItem.title,
                    })),
                }));
        },
        selectedList() {
            let selection;

            if (
                this.station?.menu?.items?.[this.selection.root]?.items
                && this.station?.menu?.items?.[this.selection.root]?.items?.[this.selection.category].items
            ) {
                selection = this.station?.menu?.items[this.selection.root]?.items[this.selection.category];
            } else if (this.station?.menu?.items?.[this.selection.root]?.items) {
                selection = this.station?.menu?.items[this.selection.root];
            }

            return {
                id: selection.id,
                category: this.station?.menu?.items?.[this.selection.root]?.title,
                list: selection.title,
            };
        },
        selectedItems() {
            try {
                let selection;

                if (
                    this.station?.menu?.items[this.selection.root]?.items
                    && this.station?.menu?.items[this.selection.root]?.items[this.selection.category].items
                ) {
                    selection = this.station?.menu?.items[this.selection.root]?.items[this.selection.category].items;
                } else if (this.station?.menu?.items[this.selection.root]?.items) {
                    selection = this.station?.menu?.items[this.selection.root]?.items;
                }

                if (selection) {
                    return selection.flatMap(item => {
                        if (item.variations && item.variations.length > 0) {
                            return item.variations.map(variation => Object.assign(JSON.parse(JSON.stringify(item)), {
                                id: item.id,
                                variation: variation.id,
                                variationName: variation.name,
                                name: `${item.name}, ${variation.name.toLowerCase()}`,
                                price: variation.price,
                            }));
                        }

                        return item;
                    });
                }
            } catch (e) {
                return [];
            }

            return [];
        },
    },
    mounted() {
        this.gtmSelection();
    },
    methods: {
        select(payload) {
            this.$set(this, 'selection', payload);
            this.gtmSelection();
        },
        navigate(page) {
            this.page = page;
            this.setLoading({
                loading: true,
            });
            this.$nextTick(() => {
                this.setLoading({
                    loading: false,
                });
            });

            if (page === 'checkout') {
                const items = this.products.flatMap(product => {
                    let extras = [];

                    if (product.extras) {
                        extras = product.extras.map(extra => ({
                            item_id: extra.id,
                            item_name: extra.title,
                            item_category: extra.list.category,
                            item_list_id: extra.list.id,
                            item_list_name: extra.list.list,
                            item_variant: extra.variationName ?? '',
                            price: extra.price,
                            quantity: extra.amount,
                        }));
                    }

                    return [
                        {
                            item_id: product.id,
                            item_name: product.title,
                            item_category: product.list.category,
                            item_list_id: product.list.id,
                            item_list_name: product.list.list,
                            item_variant: product.variationName ?? '',
                            price: product.price,
                            quantity: product.amount,
                        },
                        ...extras,
                    ];
                });

                this.$gtm.push({ ecommerce: null });
                this.$gtm.push({
                    event: 'view_cart',
                    ecommerce: {
                        currency: 'EUR',
                        value: this.productsTotal,
                        items,
                    },
                });
            }
        },
        gtmSelection() {
            const selection = this.selectedList;
            const items = this.selectedItems;

            this.$gtm.push({ ecommerce: null });
            this.$gtm.push({
                event: 'view_item_list',
                ecommerce: {
                    item_list_id: selection.id,
                    item_list_name: selection.list,
                    items: items.map(item => ({
                        item_id: item.id,
                        item_name: item.name,
                        item_category: selection.category ?? '',
                        item_list_id: selection.id,
                        item_list_name: selection.list,
                        item_variant: item.variationName ?? '',
                        price: item.price,
                    })),
                },
            });
        },
        isProductMenu({ contentType }) {
            return [
                'productMenu',
                'helmisimpukkaProductMenu',
            ].includes(contentType);
        },
    },
};
</script>
<style scoped>
.menu-selection {
  margin-bottom: 1.5rem;
}

.item {
  transition: all 0.2s ease-in-out;
  display: grid;
  grid-template-columns: 220px 1fr;
  grid-gap: 0 3rem;
  align-items: center;
  border: 1px solid var(--color-base-grey-200);
  outline: 1px solid transparent;
  border-radius: 3px;
}
.item.selected {
  border: 1px solid var(--color-primary-500);
  outline: 1px solid var(--color-primary-500);
}
.item + .padding {
  padding-bottom: 1.5rem;
}
.item .content {
  display: grid;
  grid-template-columns: 0.68fr 0.32fr minmax(auto, 125px);
  grid-gap: 0 2rem;
  padding: 2rem 1.5rem 2rem 0;
}
.item .image {
  height: auto;
  align-self: start;
  padding-top: 75%;
  border-radius: 3px 0 0 3px;
}
@media (max-width: 991px) {
  .item .image {
    border-radius: 3px 3px 0 0;
  }
}
.item .specialties {
  display: flex;
  font-size: 0.875rem;
  font-weight: 700;
  margin-top: 0.5rem;
}
.item .price-group {
  display: flex;
  align-items: flex-end;
  flex-flow: column wrap;
}
.item .price-group .price {
  white-space: nowrap;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 800;
}
.item .price-group .variation {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-base-grey-500);
}
.item .number {
  justify-self: end;
}
@media (max-width: 991px) {
  .item .content {
    grid-gap: 1rem;
  }
}
@media (max-width: 767px) {
  .item {
    grid-template-columns: 1fr;
  }
  .item .content {
    grid-template-columns: 0.5fr;
    padding: 1rem 1.5rem;
    grid-gap: 0.5rem;
  }
  .item .text {
    grid-column-end: span 2;
  }
  .item .price-group {
    align-items: flex-start;
  }
  .item .price-group .price {
    font-weight: 700;
    font-size: 1.125rem;
  }
  .item .number {
    align-self: center;
  }
}

.extras .extra {
  display: grid;
  grid-template-columns: calc(220px + 1rem) 1fr 0.5fr minmax(auto, 125px);
  grid-gap: 0 0.5rem;
  margin: 1.5rem 1.5rem 0;
  align-items: center;
}
.extras .extra .add {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
  justify-self: end;
  align-items: center;
  justify-content: center;
  background: var(--color-secondary-500);
}
.extras .extra .number {
  margin-bottom: 0;
  justify-self: end;
}
.extras .extra .price-group {
  font-size: 1.125rem;
  justify-self: end;
  align-self: center;
}
.extras .extra .price-group .price {
  font-weight: 700;
  margin-right: 1.5rem;
}
.extras .extra .ds-btn {
  padding-left: 0;
}
.extras .extra:not(:last-child) {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--color-base-grey-200);
}
@media (max-width: 991px) {
  .extras .extra .price {
    margin-right: 0.5rem;
  }
}
@media (max-width: 767px) {
  .extras .extra {
    grid-template-columns: repeat(2, 0.5fr);
    grid-gap: 0.5rem;
  }
  .extras .extra .content {
    display: flex;
    flex-flow: column nowrap;
    grid-column-end: span 2;
  }
  .extras .extra .rich-text {
    margin-top: -0.5rem;
  }
  .extras .extra .add {
    display: none;
  }
  .extras .extra .price-group {
    align-self: center;
    justify-self: start;
    margin-right: 0;
  }
}

.checkout .amount {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-base-grey-500);
}
.checkout .item .content {
  grid-template-columns: 2fr 1fr;
  padding: 0.5rem 1.5rem 0.5rem 0;
}
.checkout .item:not(:first-child) {
  margin-top: 1.5rem;
}
.checkout .item .price-group {
  grid-column-start: 2;
  grid-row-start: 1;
  grid-row-end: span 2;
}
.checkout .item .price-group .price {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 800;
}
.checkout .item .specialties {
  margin-top: 0;
}
.checkout .extra {
  grid-template-columns: calc(220px + 1rem) 1fr 0.5fr;
}
.checkout .extra .h5 {
  margin-bottom: 0.25rem;
}
.checkout .extra .price-group {
  align-self: end;
  text-align: right;
}
.checkout .extra .price-group .price {
  margin-right: 0;
}
.checkout .checkout-divider {
  border-top: 4px solid var(--color-primary-500);
  grid-column-end: span 2;
  margin: 1.5rem 0;
}
.checkout .disclaimer {
  font-size: 1rem;
  margin: 1.5rem 0;
  text-align: center;
  font-weight: 700;
}
@media (max-width: 767px) {
  .checkout .item .content {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .checkout .item .price-group {
    grid-column-start: auto;
    grid-row-start: auto;
    grid-row-end: auto;
  }
  .checkout .extra {
    grid-template-columns: 1fr;
    margin-inline: 1rem;
  }
  .checkout .extra .description {
    margin-top: 0;
  }
  .checkout .extra .price-group {
    justify-self: start;
    text-align: left;
  }
}

.totals {
  position: relative;
  background: rgb(0, 0, 0);
  color: var(--color-base-white);
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  min-height: 5rem;
}
.totals button,
.totals .ds-btn {
  width: auto;
  margin-left: 0.5rem;
  padding: 0.75rem 1rem;
}
.totals button .icon,
.totals .ds-btn .icon {
  margin-right: 0.5rem;
}
.totals button.ds-btn--secondary,
.totals .ds-btn.ds-btn--secondary {
  background: none;
  border-color: var(--color-base-white);
}
.totals button.ds-btn--secondary:disabled,
.totals .ds-btn.ds-btn--secondary:disabled {
  border-color: var(--color-base-grey-800);
  background: var(--color-base-grey-800);
}
.totals .inner {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  max-width: var(--page-max-width);
  width: 100%;
  padding: 0 1.5rem;
  margin: 0 auto;
}
.totals .inner .price {
  margin-bottom: 0;
  margin-right: auto;
}
@media (max-width: 991px) {
  .totals .inner {
    padding: 1rem 1.5rem;
    flex-flow: column wrap;
  }
  .totals .inner button,
  .totals .inner .ds-btn {
    margin-left: 0;
  }
  .totals .inner .phone {
    order: -1;
    margin-bottom: 0.5rem;
  }
  .totals .inner .price {
    order: -2;
    margin-bottom: 0.5rem;
    margin-right: 0;
    text-align: center;
  }
  .totals .inner .text {
    grid-column-end: span 2;
  }
  .totals .inner .text,
  .totals .inner .text:last-child {
    text-align: center;
  }
}
</style>
